import { gql } from "@apollo/client";

export default gql`
  mutation deleteComplianceProgramScheduledReminderMutation($reminderId: Int!) {
    deleteComplianceProgramScheduledReminder(reminderId: $reminderId) {
      complianceProgram {
        id
        scheduledReminders {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
`;
